ListItem = React.createClass
  render: ->
    <li {...@props}>{@props.text}</li>

module.exports = ListItem
